//	$: min = units.match(/C/) ? 5 : 41;
//	$: max = units.match(/C/) ? 35 : 95;
export const CONSTRAINTS_BY_UNITS = {
	F: {
		default: {
			min: 41,
			default: 72,
			max: 95,
		},
		heat: {
			min: 41,
			default: 72,
			max: 95,
		},
		cool: {
			min: 41,
			default: 72,
			max: 95,
		},
		tsh: {
			min: 1,
			max: 7,
		},
	},
	C: {
		default: {
			min: 5,
			default: 22,
			max: 35,
		},
		heat: {
			min: 5,
			default: 22,
			max: 35,
		},
		cool: {
			min: 5,
			default: 22,
			max: 35,
		},
		tsh: {
			min: 0.5,
			max: 5,
		},
	},
};
